import { internalClient } from './internalClient'

type TGetAvailabilityDateParams = {
  shop: string
  dateStart: string
  dateEnd: string
}

export async function getAvailabilityDate(params: TGetAvailabilityDateParams) {
  const response = await internalClient.post('', {
    action: 'getDates',
    ...params,
  })

  return response.data
}
